export class CostRecordMetadataDataTransfer {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operationType",
            "baseName": "operationType",
            "type": "DataTransferOperationType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostRecordMetadataDataTransfer.attributeTypeMap;
    }
    constructor() {
    }
}
